module.exports = __webpack_public_path__ + "static/media/audory-icon-button.4236ef1a.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/audory-icon-button.png
// module id = 484
// module chunks = 4